Cliente: {{customerName}} 





<!-- <div class="mt-3 flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Data</th>
            <th class="text-left px-6 py-3">Valor</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let financial of financials; let i = index" [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ financial.id }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ financial.date }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ financial.total }}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <button class="text-white cursor-pointer bg-orange-500 px-3 py-2 rounded hover:bg-orange-600">
                  <i class="pi pi-eye mx-2"><span class="ml-1">Visualizar</span></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->



  
<div class="mt-3 flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
        <p-treeTable
  [columns]="cols"
  [value]="nodes"
  [virtualScroll]="true"
  [scrollHeight]="'400px'"
  [lazy]="true"
  (onLazyLoad)="loadNodesLazy($event)"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowNode let-columns="columns">
    <tr>
      <td *ngFor="let col of columns">
        {{ rowNode.node.data[col.field] }}
      </td>
    </tr>
  </ng-template>
</p-treeTable>
    </div>
</div>